// Clés de cache React Query centralisées
// RÈGLE SÉCURITÉ : entrepriseId OBLIGATOIRE dans toute clé métier

export const queryKeys = {
  // === CHANTIERS ===
  chantiers: {
    all: (entrepriseId: string) => ['chantiers', entrepriseId] as const,
    detail: (entrepriseId: string, chantierId: string) => ['chantiers', entrepriseId, chantierId] as const,
    metrics: (entrepriseId: string, chantierId: string) => ['chantiers', entrepriseId, chantierId, 'metrics'] as const,
    status: (entrepriseId: string, chantierId: string) => ['chantiers', entrepriseId, chantierId, 'status'] as const,
    dateFin: (entrepriseId: string, chantierId: string) => ['chantiers', entrepriseId, chantierId, 'date-fin'] as const,
  },

  // === ÉQUIPE ===
  equipe: {
    all: (entrepriseId: string) => ['equipe', entrepriseId] as const,
    membre: (entrepriseId: string, membreId: string) => ['equipe', entrepriseId, membreId] as const,
    stats: (entrepriseId: string) => ['equipe', entrepriseId, 'stats'] as const,
    history: (entrepriseId: string, membreId: string) => ['equipe', entrepriseId, membreId, 'history'] as const,
  },

  // === FINANCES ===
  finances: {
    frais: (entrepriseId: string, chantierId: string) => ['finances', entrepriseId, chantierId, 'frais'] as const,
    facturesClients: (entrepriseId: string, chantierId: string) => ['finances', entrepriseId, chantierId, 'factures-clients'] as const,
    facturesFournisseurs: (entrepriseId: string, chantierId: string) => ['finances', entrepriseId, chantierId, 'factures-fournisseurs'] as const,
    paiements: (entrepriseId: string, chantierId: string) => ['finances', entrepriseId, chantierId, 'paiements'] as const,
    devis: (entrepriseId: string, chantierId: string) => ['finances', entrepriseId, chantierId, 'devis'] as const,
    budgetVentile: (entrepriseId: string, chantierId: string) => ['finances', entrepriseId, chantierId, 'budget-ventile'] as const,
    contratsST: (entrepriseId: string, chantierId: string) => ['finances', entrepriseId, chantierId, 'contrats-st'] as const,
    ajustements: (entrepriseId: string, chantierId: string) => ['finances', entrepriseId, chantierId, 'ajustements'] as const,
    paiementTotals: (entrepriseId: string, chantierId: string) => ['finances', entrepriseId, chantierId, 'paiement-totals'] as const,
  },

  // === TRÉSORERIE ===
  tresorerie: {
    prevision: (entrepriseId: string) => ['tresorerie', entrepriseId, 'prevision'] as const,
    historique: (entrepriseId: string) => ['tresorerie', entrepriseId, 'historique'] as const,
    chargesFixes: (entrepriseId: string) => ['tresorerie', entrepriseId, 'charges-fixes'] as const,
  },

  // === AFFECTATIONS ===
  affectations: {
    chantier: (entrepriseId: string, chantierId: string) => ['affectations', entrepriseId, chantierId] as const,
    calendrier: (entrepriseId: string, mois: string) => ['affectations', entrepriseId, 'calendrier', mois] as const,
    calendarAll: (entrepriseId: string) => ['affectations', entrepriseId, 'calendrier-all'] as const,
    conflits: (entrepriseId: string) => ['affectations', entrepriseId, 'conflits'] as const,
  },

  // === ALERTES ===
  alertes: {
    all: (entrepriseId: string) => ['alertes', entrepriseId] as const,
  },

  // === ANALYSE IA ===
  analyseIA: {
    chantier: (entrepriseId: string, chantierId: string) => ['analyse-ia', entrepriseId, chantierId] as const,
  },

  // === NOTIFICATIONS ===
  notifications: {
    all: (userId: string) => ['notifications', userId] as const,
  },

  // === ABONNEMENT ===
  subscription: {
    current: (entrepriseId: string) => ['subscription', entrepriseId] as const,
  },

  // === SOUS-TRAITANTS ===
  sousTraitants: {
    all: (entrepriseId: string) => ['sous-traitants', entrepriseId] as const,
  },

  // === RAPPORTS ===
  rapports: {
    chantier: (entrepriseId: string, chantierId: string) => ['rapports', entrepriseId, chantierId] as const,
    global: (entrepriseId: string) => ['rapports', entrepriseId, 'global'] as const,
  },

  // === CHARTS ===
  charts: {
    chantier: (entrepriseId: string, chantierId: string) => ['charts', entrepriseId, chantierId] as const,
    global: (entrepriseId: string) => ['charts', entrepriseId, 'global'] as const,
    globalDetailed: (entrepriseId: string, chantierIds: string[]) =>
      ['charts', entrepriseId, 'global-detailed', ...chantierIds.sort()] as const,
  },

  // === USER ===
  user: {
    roles: (userId: string) => ['user', userId, 'roles'] as const,
    profile: (userId: string) => ['user', userId, 'profile'] as const,
  },
} as const;
